import React, { useEffect, useState } from "react";
import { Button, Group, NumberInput, Select, TextInput } from "@mantine/core";
import "../Admin/Event/AdminEvent.css";

interface EventDto {
    eventID: number;
    eventName?: string;
}

const AdminCreateTicketCollection: React.FC = () => {
    const [events, setEvents] = useState<EventDto[]>([]);
    const [eventId, setEventId] = useState<number>(0);

    const [collectionName, setCollectionName] = useState<string>("");
    const [amount, setAmount] = useState<number>(25);
    const [maxDrinks, setMaxDrinks] = useState<number>(4);

    const [message, setMessage] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    // ---------------- HENT EVENTS ----------------
    useEffect(() => {
        fetch("/api/events")
            .then((r) => (r.ok ? r.json() : []))
            .then((data) => setEvents(Array.isArray(data) ? data : []))
            .catch(() => setError("Kunne ikke hente events"));
    }, []);

    // ryd beskeder når event skiftes
    useEffect(() => {
        setMessage(null);
        setError(null);
    }, [eventId]);

    const submit = async () => {
        setMessage(null);
        setError(null);

        if (!eventId) return setError("Vælg event");
        if (!collectionName.trim()) return setError("Indtast navn på samling");
        if (!amount || amount <= 0) return setError("Antal skal være > 0");
        if (maxDrinks < 0) return setError("Max drinks skal være >= 0");

        try {
            const res = await fetch("/api/admin/drink-tickets/create", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    eventId,
                    collectionName: collectionName.trim(),
                    amount,
                    maxDrinks,
                }),
            });

            if (!res.ok) {
                const text = await res.text();
                throw new Error(text || "Kunne ikke oprette billetter");
            }

            setMessage(`✅ Oprettet ${amount} billetter i "${collectionName.trim()}"`);
        } catch (e: any) {
            setError(e.message || "Ukendt fejl");
        }
    };

    return (
        <div className="form-container">
            <h2>Opret billet-samling</h2>

            {error && <p className="error-message">{error}</p>}
            {message && <p className="success-message">{message}</p>}

            <label>Event *</label>
            <Select
                placeholder="Vælg event"
                value={eventId ? String(eventId) : null}
                onChange={(val) => setEventId(val ? Number(val) : 0)}
                data={events.map((e) => ({
                    value: String(e.eventID),
                    label: e.eventName || `Event ${e.eventID}`,
                }))}
                searchable
                clearable
                nothingFoundMessage="Ingen events"
            />

            <label style={{ marginTop: 12 }}>Samling (navn) *</label>
            <TextInput
                placeholder='Fx "Billetter - Fredag"'
                value={collectionName}
                onChange={(e) => setCollectionName(e.currentTarget.value)}
            />

            <label style={{ marginTop: 12 }}>Antal personer *</label>
            <NumberInput
                min={1}
                value={amount}
                onChange={(val) => setAmount(Number(val || 0))}
            />

            <label style={{ marginTop: 12 }}>Drinks pr billet *</label>
            <NumberInput
                min={0}
                value={maxDrinks}
                onChange={(val) => setMaxDrinks(Number(val || 0))}
            />

            <Group justify="flex-end" mt="md">
                <Button className="add-btn" onClick={submit}>
                    Opret
                </Button>
            </Group>
        </div>
    );
};

export default AdminCreateTicketCollection;